import { Skeleton } from "./Skeleton";

/**
 * Suspense fallback shown while a lazy-loaded route chunk streams in.
 * Padding mirrors AppShell's main element so layout doesn't shift when
 * the real page mounts. Skeletons are the design-system loading
 * primitive, so we lean on them instead of inventing a spinner.
 */
export function RouteFallback() {
  return (
    <div style={{ padding: "var(--s-6) var(--s-5)" }}>
      <Skeleton variant="title" width="40%" />
      <div style={{ marginTop: "var(--s-4)" }}>
        <Skeleton variant="line" width="70%" />
        <Skeleton variant="line" width="60%" />
        <Skeleton variant="line" width="80%" />
      </div>
    </div>
  );
}
